app.service("OrderService", ['$rootScope', '$location', '$state', function ($rootScope, $location, $state) {

    const service = this;

    const requestService = $rootScope.service.request;
    const siteHelper = $rootScope.site_helper;

    const OrderEntryModel = function () {
        this.current_order_id = '';
        this.current_order = null;
        this.save_order_in_progress = {};
        this.additional_save_order_required = {};
        this.is_order_initialized = false;
        this.saveOrderCallbacks = {};
        this.initializedCurrentOrderCallbacks = [];
    };

    this.model = new OrderEntryModel();
    const model = this.model;


    this.saveOrder = function (order, callback) {
        let orderID = "";
        let isCurrentOrder = false;
        let callbackID;

        if (!order) {
            order = model.current_order;
        }

        if (order._id) {
            orderID = order._id;
        }

        callbackID = orderID ? orderID : "NEW_ORDER";
        isCurrentOrder = !orderID || model.current_order._id === order._id;

        if (callback) {
            if (!model.saveOrderCallbacks[callbackID]) {
                model.saveOrderCallbacks[callbackID] = [];
            }
            model.saveOrderCallbacks[callbackID].push(callback);
        }

        function callSaveOrder(order) {
            const endpoint = '/request/api.php/orders/' + orderID;

            model.save_order_in_progress[callbackID] = true;
            const sentOrder = JSON.parse(JSON.stringify(order))
            requestService.postJsonRequest(endpoint, order, function (success, order, errors) {
                service.addAdditionalOrderData(order);
                delete model.save_order_in_progress[callbackID];

                const additionalOrder = model.additional_save_order_required[callbackID];
                if (additionalOrder) {
                    delete model.additional_save_order_required[callbackID];
                    callSaveOrder(additionalOrder);
                    return;
                }

                if (order) {
                    if (sentOrder.two_person_delivery && sentOrder._allow_two_person_delivery && !order._allow_two_person_delivery) {
                        sentOrder.two_person_delivery = false;
                        callSaveOrder(sentOrder);
                        return;
                    }
                    if (sentOrder.collection && sentOrder._collectible && !order._collectible) {
                        sentOrder.collection = false;
                        callSaveOrder(sentOrder);
                        return;
                    }
                    if (order._errors) {
                        if (order.lines.length > 0 && order.lines[0]._errors) {
                            success = false;
                            siteHelper.addErrorMessage(order.lines[0]._errors, errors);
                        }
                    }

                    if (isCurrentOrder && model.current_order._id && model.current_order._id !== order._id) {
                        success = false;
                        isCurrentOrder = false;
                        siteHelper.addErrorMessage("Current Order Changed", errors);
                    }
                    if (isCurrentOrder) {
                        service.setCurrentOrder(order);
                    }
                }

                if (model.saveOrderCallbacks[callbackID]) {
                    for (let i = 0; i < model.saveOrderCallbacks[callbackID].length; i++) {
                        model.saveOrderCallbacks[callbackID][i](success, order, errors);
                    }
                    delete model.saveOrderCallbacks[callbackID];
                }
            })
        }

        if (model.save_order_in_progress[callbackID]) {
            model.additional_save_order_required[callbackID] = order;
        } else {
            callSaveOrder(order);
        }
    }


    this.addAdditionalOrderData = function (order) {
        if (!order || !order.lines) {
            return;
        }
        let hasNonRigid = false;
        for (let i = 0; i < order.lines.length; i++) {
            const line = order.lines[i];
            if(!line.rigid){
                hasNonRigid = true;
            }
            if (!line._summary) {
                delete line.full_summary;
                continue;
            }
            const fullSummary = line._summary.slice();
            if (line._sublines) {
                for (let j = 0; j < line._sublines.length; j++) {
                    const subline = line._sublines[j];
                    if (subline._sublines) {
                        for (let k = 0; k < subline._sublines.length; k++) {
                            const subline_subline = subline._sublines[k];
                            if (subline_subline._description) {
                                if (!fullSummary.includes(subline_subline._description)) {
                                    fullSummary.push(subline_subline._description)
                                }
                            }
                        }
                    }
                }
            }
            line.full_summary = fullSummary;
        }
        order.has_non_rigid = hasNonRigid;
    }

    this.submitOrder = function (order, callback) {

        if (!order || !order._id) {
            if (callback) {
                callback(false, null, siteHelper.addErrorMessage("Invalid Order"))
            }
            return;
        }

        const endpoint = '/request/api.php/orders/' + order._id + '/submit';

        requestService.postJsonRequest(endpoint, order, function (success, order, errors) {

            if (order) {
                service.addAdditionalOrderData(order);
                if (order._errors) {
                    success = false;
                    errors.unshift(siteHelper.addErrorMessage("Sorry the order did not submit. The following issue(s) occurred: ")[0]);
                    if (order.lines.length > 0 && order.lines[0]._errors) {
                        siteHelper.addErrorMessage(order.lines[0]._errors, errors);
                    } else {
                        siteHelper.addErrorMessage(order._errors, errors);
                    }
                    if(order._despatch_groups){
                        for(let i = 0; i < order._despatch_groups.length; i ++){
                            let despatchGoup = order._despatch_groups[i];
                            if(despatchGoup._errors){
                                siteHelper.addErrorMessage(despatchGoup._errors, errors);
                            }
                        }
                    }
                }
            }
            if (callback) {
                callback(success, order, errors);
            }
        })
    }

    this.deleteOrder = function (order, callback) {
        const orderID = order._id;
        const endpoint = '/request/api.php/orders/' + orderID;

        order.submit_order = false;
        order.save_order = false;
        order.deleteOrder = true;
        requestService.deleteJsonRequest(endpoint, order, callback)
    }

    this.requestOrder = function (orderID, callback) {

        function handleCallback(success, order, messages) {
            if (callback) {
                callback(success, order, messages);
            }
        }

        const endpoint = '/request/api.php/orders/' + orderID + '?include_lines=true';
        requestService.getRequest(endpoint, function (success, order, messages) {
            service.addAdditionalOrderData(order);

            const isCurrentOrder = model.current_order._id === orderID;
            if (isCurrentOrder) {
                if (success) {
                    service.setCurrentOrder(order);
                } else {
                    $rootScope.service.order.startNewOrder();
                }
            }
            handleCallback(success, order, messages)
        });
    }

    this.requestConsignments = function (orderID, callback) {

        const endpoint = '/request/api.php/orders/' + orderID + '/consignments';
        requestService.getRequest(endpoint, callback);
    }

    this.applyAccountDataToCurrentOrder = function () {
        if (model.current_order) {
            if ($rootScope.model.account.customer_data && !model.current_order.customer_code) {
                model.current_order.customer_code = $rootScope.service.account.getCustomerCode();
                model.current_order.currency = $rootScope.service.currency.currencyData().id;
            }
            if ($rootScope.model.staff.is_staff) {
                model.current_order.payment_type = 'staff';
            }
        }
    }

    function resetCurrentOrder(isQuote, orderID) {

        const type = !isQuote ? "weborder" : "webquote";

        const order = {
            lines: [],
            type: type,
            despatch_type: 'standard',
            payment_type: 'account',
            _id: orderID ? orderID : ''
        }
        service.addAdditionalOrderData(order);

        service.setCurrentOrder(order);
    }

    this.startNewOrder = function (isQuote) {

        localStorage.removeItem('current_order_id');
        resetCurrentOrder(isQuote);

        $rootScope.service.cache_browse.removeCategoryCaches();
    }

    this.initCachedOrder = function () {

        function handleInitialized() {
            model.is_order_initialized = true;
            for (let i = 0; i < model.initializedCurrentOrderCallbacks.length; i++) {
                model.initializedCurrentOrderCallbacks[i]();
            }
            model.initializedCurrentOrderCallbacks.length = 0;
        }

        const currentOrderID = localStorage.getItem('current_order_id');

        resetCurrentOrder(false, currentOrderID);

        const order = model.current_order;

        if (order._id) {
            $rootScope.service.order.requestOrder(order._id, function (success, order) {
                handleInitialized();
                if (!success || (order._status !== "SAVED" && order._status !== "SAGEPAY")) {
                    service.startNewOrder();
                }
            });
        } else {
            handleInitialized();
        }
    }

    this.requireInitializedCurrentOrder = function (callback) {
        if (model.is_order_initialized) {
            callback();
            return;
        }
        model.initializedCurrentOrderCallbacks.push(callback)
    }

    this.setCurrentOrder = function (order) {

        const orderID = order._id ? order._id : null;

        model.current_order = order;

        service.applyAccountDataToCurrentOrder();

        if (orderID) {
            localStorage.setItem('current_order_id', orderID);
        } else {
            localStorage.removeItem('current_order_id');
        }

        const isQuote = $rootScope.service.order_helper.isOrderQuote(order);
        const body = angular.element(document).find('body');
        if (!isQuote) {
            body.removeClass("is_quote");
            body.addClass("is_order");
        } else {
            body.removeClass("is_order");
            body.addClass("is_quote");
        }

        const categoryID = order.category_cache?.category_id ?? null;
        if(categoryID){
            const existingCache = $rootScope.service.cache_browse.requireCategoryCache(order.category_cache.category_id);
            for(let key in order.category_cache){
                existingCache[key] = order.category_cache[key];
            }
            $rootScope.service.cache_browse.saveCategoryCache(categoryID);
        }

        $rootScope.$broadcast("current_order_replaced");

    }

    this.acceptTransfer = function (order_id, callback) {
        const endpoint = '/request/api.php/orders/'+order_id+'/accept';
        requestService.postJsonRequest(endpoint, null, callback)
    }

    this.rejectTransfer = function (order_id, callback) {
        const endpoint = '/request/api.php/orders/'+order_id+'/cancel';
        requestService.postJsonRequest(endpoint, null, callback)
    }

}]);